"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cvTypography = exports.cvBreakpoint1920 = exports.cvBreakpoint1280 = exports.cvBreakpoint1024 = exports.cvBreakpoint768 = exports.cvBreakpoint0 = exports.cvFontSize = exports.cvFontFamily = exports.cvImpersonationRed = exports.cvBody = exports.cvStroke = exports.cvGreen = exports.cvYellow = exports.cvBlue = exports.cvWhite = exports.cvRed = exports.cvGray = void 0;

var getThemeColor = function getThemeColor(color) {
  return function (_ref) {
    var carvana = _ref.theme.carvana;
    return carvana[color];
  };
};

var getColorVariant = function getColorVariant(color) {
  return function (variant) {
    return function (_ref2) {
      var carvana = _ref2.theme.carvana;
      return carvana[color][variant];
    };
  };
};

var getBreakpointValue = function getBreakpointValue(size) {
  return function (_ref3) {
    var values = _ref3.theme.breakpoints.values;
    return values[size];
  };
};

var cvTypography = function cvTypography(attr) {
  return function (_ref4) {
    var typography = _ref4.theme.typography;
    return typography[attr];
  };
};

exports.cvTypography = cvTypography;
var cvGray = getColorVariant('gray');
exports.cvGray = cvGray;
var cvRed = getColorVariant('red');
exports.cvRed = cvRed;
var cvWhite = getColorVariant('white');
exports.cvWhite = cvWhite;
var cvBlue = getColorVariant('blue');
exports.cvBlue = cvBlue;
var cvGreen = getColorVariant('green');
exports.cvGreen = cvGreen;
var cvYellow = getColorVariant('yellow');
exports.cvYellow = cvYellow;
var cvStroke = getColorVariant('stroke');
exports.cvStroke = cvStroke;
var cvBody = getThemeColor('body');
exports.cvBody = cvBody;
var cvImpersonationRed = getThemeColor('impersonationRed');
exports.cvImpersonationRed = cvImpersonationRed;
var cvFontFamily = cvTypography('fontFamily');
exports.cvFontFamily = cvFontFamily;
var cvFontSize = cvTypography('fontSize');
exports.cvFontSize = cvFontSize;
var cvBreakpoint0 = getBreakpointValue('xs');
exports.cvBreakpoint0 = cvBreakpoint0;
var cvBreakpoint768 = getBreakpointValue('sm');
exports.cvBreakpoint768 = cvBreakpoint768;
var cvBreakpoint1024 = getBreakpointValue('md');
exports.cvBreakpoint1024 = cvBreakpoint1024;
var cvBreakpoint1280 = getBreakpointValue('lg');
exports.cvBreakpoint1280 = cvBreakpoint1280;
var cvBreakpoint1920 = getBreakpointValue('xl');
exports.cvBreakpoint1920 = cvBreakpoint1920;